import { useEffect, useState } from "react";
import CardPlanosResidenciaisTrimestrais from "./CardPlanosResidenciaisTrimestrais";
import Footer from "./Footer";
import NavBar from "./NavBar";
import axios from "axios";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { motion } from "framer-motion";
import { API_BASE_URL } from "../services/api";

export default function PlanosResidenciaTrimestre() {
  const [planosResidencias, setPlanosResidencia] = useState([]);
  const [loading, setLoadiang] = useState(false);
  const navigate = useNavigate();

  async function mostrarCards() {
    try {
      setLoadiang(true);
      const token = localStorage.getItem("token");
      const planosresidenciais = await axios.get(
        `${API_BASE_URL}/planostrimestraisresidenciais`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (planosresidenciais.data[0]) {
        setPlanosResidencia([...planosresidenciais.data]);
      } else {
        alert("Não há planos residenciais disponíveis!");
      }
      setLoadiang(false);
    } catch (erro) {
      console.log(erro);
      setLoadiang(false);
    }
  }

  useEffect(() => {
    mostrarCards();
  }, []);

  return (
    <div className="flex h-screen flex-col justify-between">
      {/* NavBar */}
      <div className="bg-blue-500 text-gray-200 w-full sticky top-0 z-10">
        <NavBar />
      </div>

      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div className="w-[90%] px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 mx-auto my-6">
          <motion.button
            className="group"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(-1)}
          >
            <div className="flex md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">Voltar</span>
              </div>
            </div>
          </motion.button>

          <div className="flex flex-wrap justify-center gap-6 mt-4">
            {planosResidencias.map((plano, index) => (
              <motion.div
                key={plano.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <CardPlanosResidenciaisTrimestrais
                  id={plano.id}
                  descricao={plano.descricao}
                  validade={plano.validade}
                  preco={plano.preco}
                  titulo={plano.plano}
                  className="w-full sm:w-[48%] md:w-[45%] lg:w-[30%]"
                />
              </motion.div>
            ))}
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="bg-blue-500 text-gray-200 w-full">
        <Footer />
      </div>
    </div>
  );
}
